import { css } from "@emotion/react"
import { Dialog } from "@planningcenter/tapestry-react"
import { ConnectComponentsProvider, ConnectNotificationBanner } from "@stripe/react-connect-js"
import Loading from "components/ui/Loading/Loading"
import useStripeConnectInstance from "hooks/use_stripe_connect_instance"
import PropTypes from "prop-types"
import { useState } from "react"

const dialogOverride = css`
  & dialog button:not([aria-label="Close"]) {
    color: var(--t-text-color-status-neutral);
    background-color: var(--t-fill-color-button-neutral-outline-dim-default);
    border: 1px solid var(--t-border-color-button-neutral);

    &:hover {
      background-color: var(--t-fill-color-button-neutral-outline-dim-hover);
    }

    &.active {
      background-color: var(--t-fill-color-button-neutral-outline-dim-active);
    }
  }
`

const ActionItems = ({ dialogRef, onNotificationsChange }) => {
  const { stripeConnectInstance } = useStripeConnectInstance()
  const [isLoading, setIsLoading] = useState(true)

  const handleNotificationsChange = response => {
    setIsLoading(false)
    onNotificationsChange(response.total)
  }

  return (
    <div css={dialogOverride}>
      <Dialog
        dialogRef={dialogRef}
        title="Action Required"
        subtitle="Your Stripe account admin must provide the requested information below."
        body={
          <>
            {isLoading && <Loading />}
            <ConnectComponentsProvider connectInstance={stripeConnectInstance}>
              <ConnectNotificationBanner onNotificationsChange={handleNotificationsChange} />
            </ConnectComponentsProvider>
          </>
        }
      />
    </div>
  )
}

ActionItems.propTypes = {
  dialogRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) })
  ]),
  onNotificationsChange: PropTypes.func.isRequired
}

export default ActionItems
